
const config = {
  liveStreamUrl: 'https://stream.bff.fm/1/mp3.mp3'
};

module.exports = config;



//////////////////
// WEBPACK FOOTER
// ./src/js/config/bff.js
// module id = 9
// module chunks = 0 1